import { render, staticRenderFns } from "./addServiceDialog.vue?vue&type=template&id=f5d3d8e0&scoped=true"
import script from "./addServiceDialog.vue?vue&type=script&lang=js"
export * from "./addServiceDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5d3d8e0",
  null
  
)

export default component.exports